import persist from './persist'
import auth from './auth'
import axios from './axios'
import icon from './icon'
import repository from './repository'
import meta from './meta'
import page from './page'
import wovn from './wovn'
import utils from './utils'
import config from './config'
import pref from "./pref"
import enums from "./enums";
import menuIcons from "./menuIcons";
import moment from "./moment"
import colors from "./colors"
import modal from "./modal";

Number.prototype.format = function () {
  return new Intl.NumberFormat().format(this)
}

export default [persist, auth, axios, icon, repository, meta, page, wovn, utils, config,pref,moment,enums,menuIcons,colors,modal]
